export { default as Avatar } from './src/Avatar'
